import React, { Component, Fragment } from "react";
import YouTubeVideoPreview from './YouVideoPreview'
import WatchDemo from './../modals/watchADemo'
import Header from './Header';
import Footer from './Footer';

class Homepage extends Component {

    constructor() {
        super()
        this.state = {
            isOpen: false,
        }
        this.openModal = this.openModal.bind(this)
    }

    openModal() {
        this.setState({ isOpen: true })
    }

    render() {

        return (
            <Fragment>
                <YouTubeVideoPreview channel='youtube' isOpen={this.state.isOpen} videoId='owhuBrGIOsE' onClose={() => this.setState({ isOpen: false })} />
                <Header {...this.props} />
                <div className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed">
                    <div className="container">
                        <div className="row">
                            <div className="content-box video-popup">
                                <div className="col-md-10 col-md-offset-1">
                                    <div className="content">
                                        <h1>Technology to help you build and share your workouts easily</h1>
                                        <p>Fitbanx is the tool you need to train more clients remotely and grow your business</p>
                                        <a className="btn circle btn-light border btn-md" data-toggle="modal"
                                            data-target="#freedownload">Try it free</a>
                                        <WatchDemo mrgnClass={""}></WatchDemo>
                                        <img src="assets/img/main-image-720.png" alt="main" />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="companies-area ">
                    <div className="container">
                        <div className="row1">
                            <h2 className="text-center">Some popular brands using Fitbanx. It's time for you to join the crowd.</h2>
                            <div className="info">
                                <img src="assets/img/brands/core.png" width="180px" alt="displayImage" />
                                <img src="assets/img/brands/D1.jpg" width="80px" alt="displayImage" />
                                <img src="assets/img/brands/fit-simplify.png" width="110px" alt="displayImage" />
                                <img src="assets/img/brands/flyte.jpg" width="110px" alt="displayImage" />
                                <img src="assets/img/brands/gorilla-bow.png" width="180px" alt="displayImage" />
                                <img src="assets/img/brands/rit-fit.png" width="80px" alt="displayImage" />
                                <img src="assets/img/brands/rrlogo.png" width="80px" alt="displayImage" />
                                <img src="assets/img/brands/tribe_fitness.png" width="160px" alt="displayImage" />
                            </div>
                            <div className="clearfix"></div>
                            <h3 className="text-center">
                                We help trainers, coaches, and fitness brands save time and make more money by making it easy to share their creative workouts in today's digital world.</h3>
                            <hr />
                        </div>
                    </div>
                </div>
                <div id="features" className="features-area cell-items default-padding">
                    <div className="container">

                        <div className="row">
                            <div className="features-items icon-solid">
                                <div className="col-md-12">
                                    <div className="items-box inc-cell">
                                        <div className="col-md-4 col-sm-4 equal-height text-center">
                                            <div className="item">
                                                <div className="icon">
                                                    <img width="85px" src="assets/img/return.png" alt="" />
                                                </div>
                                                <div className="info">
                                                    <h4>Subscription income</h4>
                                                    <p>
                                                        Get paid a monthly subscription by your clients, fans, and followers in exchange for fresh, fun, weekly workouts featuring YOU and your creative workout ideas.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height text-center">
                                            <div className="item">
                                                <div className="icon">
                                                    <i className="flaticon-customer-service"></i>
                                                </div>
                                                <div className="info">
                                                    <h4>Expand your services</h4>
                                                    <p>
                                                    Training clients remotely has never been easier. Create extra revenue streams by easily building and sharing custom workouts for customers all over the nation.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height text-center">
                                            <div className="item">
                                                <div className="icon">
                                                    <i className="flaticon-analysis"></i>
                                                </div>
                                                <div className="info">
                                                    <h4>Connect & engage better</h4>
                                                    <p>
                                                        Produced exercise videos are cumbersome for you and your customers. Publish fresh content in our IOS and Android app in minutes to keep your customers better connected and engaged.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 col-sm-12 text-center">
                                            <a style={{ 'marginTop': '50px' }}
                                                className="btn circle btn-light border btn-md"
                                                data-toggle="modal" data-target="#freedownload">Try it free</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb">
                                <img src="assets/img/true-digital-experience.png" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info">
                                <h3>A true digital customer experience</h3>
                                <p>
                                    The only app that allows you to video yourself performing exercises and then prescribe workouts NOT dependent on the internet. Your customers will be able to start, stop, skip, and replay exercises and workouts on their own time. No streaming hang ups. (No camera or fancy equipment required)
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb pull-right">
                                <img src="assets/img/build.png" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info pull-left">
                                <h3>Build & assign custom workouts easily</h3>
                                <p>
                                    Build and assign workouts to clients, friends, and groups with our easy-to-use workout building technology and 1,000 exercise video library. If we don’t have the exercise you want, simply video yourself. You can share workouts for free or sell for any price you wish.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb">
                                <img src="assets/img/track-and-analyze.png" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info">
                                <h3>Track and analyze revenue easily</h3>
                                <p>
                                    We make it easy for you to track your progress and revenue. You don’t need spreadsheets or cumbersome tracking tools.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb pull-right">
                                <img src="assets/img/simple_payments.png" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info pull-left">
                                <h3>Simple payment system</h3>
                                <p>
                                    We do all the billing so you don’t have to worry about collecting payments and tracking customers. Your payments occur automatically and seamlessly on a monthly basis.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed">
                    <div className="container">
                        <div className="row">
                            <div style={{ 'padding': '40px 0' }} className="content-box video-popup">
                                <div className="col-md-10 col-md-offset-1">
                                    <div className="content">
                                        <h2>Start building and sharing your workouts today</h2>
                                        <a className="btn circle btn-light border btn-md"
                                            data-toggle="modal" data-target="#freedownload">Try it free</a>
                                        <WatchDemo></WatchDemo>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer {...this.props} />
            </Fragment>
        )
    }
}

export default Homepage



// WEBPACK FOOTER //
// ./src/components/Homepage.js